export enum PraciceSectionTypes {
    StopWatch = "StopWatch",
    Counter = "Counter",
    ToogleSwtich = "ToogleSwtich",
    toDOList = "toDOList",
    stopWatchOwn = "stopWatchOwn",
}